var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-store" }
          }),
          _vm._v(" Produto\n    ")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTabVouchers,
                expression: "showTabVouchers"
              }
            ],
            attrs: {
              slot: "title",
              name: "vouchers",
              label: _vm.$t("vouchers")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic-data" } },
            [
              _c("basic-data", {
                on: { set_reward_product_type: _vm.setRewardProductType }
              })
            ],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "vouchers", "keep-alive": "" } },
            [_c("vouchers", { attrs: { reward_id: _vm.reward_id } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }